module.exports = __webpack_public_path__ + "img/Talk-with-God.864f5ada.jpg";